import type { Marker } from "@googlemaps/markerclusterer";
import { useCallback } from "react";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { Poi } from "../Map_view";

export type LocationMarkerProp = {
  location: Poi;
  onClick: (location: Poi) => void;
  setMarkerRef: (marker: Marker | null, key: number) => void;
};

/**
 * Wrapper Component for an AdvancedMarker for a single location.
 */

export const LocationMarker = (props: LocationMarkerProp) => {
  const { location, onClick, setMarkerRef } = props;

  const handleClick = useCallback(() => onClick(location), [onClick, location]);
  const ref = useCallback(
    (marker: google.maps.marker.AdvancedMarkerElement) => setMarkerRef(marker, location.key),
    [setMarkerRef, location.key]
  );

  return (
    <AdvancedMarker position={location.location} ref={ref} onClick={handleClick}>
      <span>
        <svg className="mt-1" width="33" height="40" viewBox="0 0 33 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="33" height="40" fill="none" />
          <path
            d="M16 0C20.2435 1.85654e-07 24.3129 1.72423 27.3135 4.79297C30.314 7.86166 31.9999 12.0235 32 16.3633C32 29.0887 16.0047 39.9968 16 40C15.9986 39.9991 0 29.09 0 16.3633C9.21435e-05 12.0235 1.68601 7.86166 4.68652 4.79297C7.68712 1.72423 11.7565 0 16 0ZM16 10.9092C13.0546 10.9092 10.6672 13.351 10.667 16.3633C10.667 19.3757 13.0545 21.8184 16 21.8184C18.9455 21.8184 21.333 19.3757 21.333 16.3633C21.3328 13.351 18.9454 10.9092 16 10.9092Z"
            fill="#2D4FC6"
          />
        </svg>
      </span>
    </AdvancedMarker>
  );
};
